import * as React from 'react';
import * as styles from './styles.css';

export interface IContainerProps {
  children: React.ReactNode;
}

export function Container({ children }: IContainerProps) {
  return <div className={styles['container']}>{children}</div>;
}
